
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25-11.193 25-25 25zm0-5c11.046 0 20-8.954 20-20S36.046 5 25 5 5 13.954 5 25s8.954 20 20 20zm8.752-20.832l-12.197-8.13a1 1 0 00-1.555.83v16.265a1 1 0 001.552.83l12.2-8.13a1 1 0 000-1.665z","fill":"#fff"}})])
          )
        }
      }
    